import React, {useContext} from 'react';
import {useMap} from 'react-leaflet'
import {CCM} from "./sgp-results-react"

const DayTaskRenderer = ({day}) => {
    const map = useMap()

    const heightFt=day.r.m ? true : false;

    //if (!map || !map.ccmap) return

    map.ccmap.taskLayer.clearLayers();

    CCM.task.draw(day.k,map.ccmap.taskLayer);
    map.fitBounds(map.ccmap.taskLayer.getBounds());

}

export default DayTaskRenderer